
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
              <v-text-field
              label="Código de Habilidade"
              v-model="form.filters.codigoHabilidade"
              outlined
              dense
              ></v-text-field>
          </v-col>
          <v-col cols="3">
              <v-text-field
              label="Unidade Temática"
              v-model="form.filters.unidadeTematica"
              outlined
              dense
              ></v-text-field>
          </v-col>
          <sca-select-ativo
              :cols="2"
              :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
              v-model="form.filters.situacao"
          ></sca-select-ativo>
        </v-row>
        <v-row class="d-flex justify-center mt-3">
          <sca-date-picker
            :cols="2"
            label="Data Início"
            v-model="form.filters.dataInicio"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
          <sca-date-picker
          :cols="2"
            v-model="form.filters.dataFim"
            label="Data Final"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headersAnalitico"
        :items="form.lists.listRelatorios"
        :items-per-page="form.itemsPerPage"
        :footer-props="$footerProps"
        show-expand
        sort-by="dataAcao"
        :sort-desc="true"
        item-key="id"
        :expanded.sync="expanded"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="codigosDeHabilidade" :colspan="headers.length">
            <v-chip-group active-class="primary--text" column>
              <v-chip class="chip-codigoDeHabilidade" v-for="(codigoDeHabilidade, i) in item.codigoList" :key="i">
                <v-icon class="codigoDeHabilidade" small>
                  mdi-checkbox-marked-circle-outline
                </v-icon>
                {{ codigoDeHabilidade.nome }}
              </v-chip>
            </v-chip-group>
          </td>
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataAcao`]="{ item }">
          {{ $formatarDataHora(item.dataAcao) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorioPdf"
        @cancel="baixarCSVRelatorio"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
  import pageLoadingMixin from "mixins/page-loading.mixin";
  import RelatorioDeLog from "services/relatorios-log/manter-unidade-tematica.service";
  export default {
      name: "RelatorioLogUnidadeTematica",
      mixins: [pageLoadingMixin, RelatorioDeLog],

      data: () => ({
      onReport: false,
      expanded: [],
      form: {
          filters: {
              unidadeTematica: null,
              codigoHabilidade: null,
              situacao: null,
              dataInicio: null,
              dataFim: null,
          },
          lists: {
              listRelatorios: [],
          },
      },
      headersAnalitico: [
          { text: "Unidade Temática", align: "center", value: "nome" },
          { text: "Código de Habilidade", align: "center", value: "data-table-expand"},
          { text: "Situação", align: "center", value: "ativo" },
          { text: "Data/Hora da ação", align: "center", value: "dataAcao" },
          { text: "Ação", align: "center", value: "acao" },
      ],
      }),
    methods: {
      payload(){
        return {
          dataInicial: this.form.filters.dataInicio,
          dataFinal: this.form.filters.dataFim,
          codigo: this.form.filters.codigoHabilidade,
          nome: this.form.filters.unidadeTematica,
          situacao: this.form.filters.situacao,
        };
      },
      async buscarRelatorios() {
          const isValid = this.validarDatas();
          if (!isValid) return;
          if (!this.verificarFiltrosPreenchidos()) return;
          this.showPageLoading();
          try {
          const payloadData = this.payload();
          const { data } = await this.$obterRelatorioLogUnidadeTematica({ params: payloadData });
          this.processarRespostaRelatorio(data);
          } finally {
          this.hidePageLoading();
          }
      },

      validarDatas() {
        const { dataInicio, dataFim } = this.form.filters;

        if (dataInicio && dataFim) {
          if (new Date(dataFim) < new Date(dataInicio)) {
            this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
            return false;
          }
          if (new Date(dataInicio) > new Date(dataFim)) {
            this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
            return false;
          }
        }
        return true;
      },

      verificarFiltrosPreenchidos() {
        const { codigoHabilidade, unidadeTematica, situacao, dataInicio, dataFim } = this.form.filters;
        if (!codigoHabilidade && !unidadeTematica && situacao == null && !dataInicio && !dataFim) {
          this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
          return false;
        }
        return true;
      },

      async baixarCSVRelatorio() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogCSVUnidadeTematica({ params: this.form.filters });
        this.$baixarRelatorioCSV(data, `SCA.RelatórioDeLogDeUnidadeTemáticaCSV`);
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      async baixarRelatorioPdf() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogPDFUnidadeTematica({ params: this.form.filters });
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SCA.RelatórioDeLogDeUnidadeTemática.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      processarRespostaRelatorio(data) {
        this.form.lists.listRelatorios = data.lista;
      },

      resetForm() {
        this.form.filters.dataInicio = null;
        this.form.filters.dataFim = null;
        this.form.filters.tipoProfissional = null;

        this.$nextTick(() => {
          this.$set(this.form.filters, 'dataInicio', null);
          this.$set(this.form.filters, 'dataFim', null);
        });
        this.form.filters.codigoHabilidade = null;
        this.form.filters.situacao = null;
        this.form.filters.unidadeTematica = null;

        this.form.lists.listRelatorios = [];
        this.expanded = [];
      }
    },
  };
</script>
<style scoped>
.codigosDeHabilidade {
padding: 1em !important;
text-align: center;
font-weight: 500;
}
.codigoDeHabilidade {
padding-right: 0.5em;
}
</style>
